import { Leader } from '@fantaz/shared/data-access/models';
import { createAction, props } from '@ngrx/store';

export const loadLeaderBoard = createAction(
  '[LeaderBoard Page] Init',
  props<{
    eventPrototypeUuid: string;
    eventScheduleUuid: string;
    username: string;
    pageIndex?: number;
    pageSize?: number;
  }>(),
);

export const loadLeaderBoardSuccess = createAction(
  '[LeaderBoard/API] Load LeaderBoard Success',
  props<{ leaderBoard: Leader[]; total: number }>(),
);

export const loadLeaderBoardFailure = createAction(
  '[LeaderBoard/API] Load LeaderBoard Failure',
  props<{ error: any }>(),
);
